import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { setSeo } from "@/lib/seo";

/**
 * HeyCatch campaign short links.
 *
 * HeyCatch reserves every single-character path - /a to /z and /0 to /9 - for
 * campaign attribution. Those URLs MUST keep reaching the app so the HeyCatch
 * SDK (loaded in index.html, before React) can read the path and attribute the
 * visit. That is why they are routed here explicitly and are NOT handled by the
 * 404 route: a blanket catch-all 404 would break every campaign link.
 *
 * What happens here:
 *   1. The SDK has already initialised and seen the short path by this point.
 *   2. We mark the URL noindex so campaign links never enter the index.
 *   3. We replace the history entry with "/" so the visitor lands on the real
 *      homepage with a clean, canonical URL and no extra back-button step.
 *
 * Nothing is sent to HeyCatch from this component - attribution is entirely the
 * SDK's own autocapture, and no campaign value is forwarded as event data.
 */
export default function CampaignRedirect() {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    setSeo({
      title: "Sponsor Me",
      description:
        "Sponsor Me helps you find a volunteer peer recovery sponsor online. Browse profiles free, read their approach, then request a connection.",
      path: location.pathname,
      index: false,
      schema: null,
    });
    // Let the analytics SDK observe the short path for a moment, then land the
    // visitor on the homepage without leaving the short link in history.
    const timer = setTimeout(() => navigate("/", { replace: true }), 150);
    return () => clearTimeout(timer);
  }, [location.pathname, navigate]);

  return (
    <div className="min-h-[50vh] flex items-center justify-center" data-testid="campaign-redirect">
      <p className="text-sm text-[#4B5A60]">Opening Sponsor Me...</p>
    </div>
  );
}
